import { createPinia } from "pinia";

const storeInstance = createPinia();

export { storeInstance };
